export const GoogleIcon = () => (
  <svg width="18" height="18" viewBox="0 0 24 24" fill="none">
    <path
      d="M21.82 10.23H12v3.77h5.59c-.24 1.28-1 2.37-2.08 3.1l3.22 2.5c1.88-1.74 2.97-4.3 2.97-7.3 0-.64-.06-1.27-.16-1.07z"
      fill="#4285F4"
    />
    <path
      d="M12 22c2.7 0 4.97-.9 6.63-2.4l-3.22-2.5c-.9.6-2.05.97-3.41.97-2.62 0-4.84-1.77-5.63-4.15H3.06v2.57C4.72 19.76 8.08 22 12 22z"
      fill="#34A853"
    />
    <path
      d="M6.37 13.92a6.04 6.04 0 0 1 0-3.84V7.51H3.06a10 10 0 0 0 0 8.98l3.31-2.57z"
      fill="#FBBC05"
    />
    <path
      d="M12 5.93c1.47 0 2.79.5 3.83 1.5l2.87-2.87C17 2.65 14.73 2 12 2 8.08 2 4.72 4.24 3.06 7.51l3.31 2.57c.79-2.38 3.01-4.15 5.63-4.15z"
      fill="#EA4335"
    />
  </svg>
);
